/* eslint-disable @typescript-eslint/no-explicit-any */
import { customAxios } from 'api/mutator/custom-axios'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P
) => any
  ? P
  : never

export interface AlgoPriceResponseBody {
  aud?: number
  cad?: number
  chf?: number
  eur?: number
  gbp?: number
  jpy?: number
  usd?: number
}

/**
 * Fetch recent ALGO price in various currencies.
 * @summary algoPrice nfd
 */
export const nfdAlgoPrice = (options?: SecondParameter<typeof customAxios>) => {
  return customAxios<AlgoPriceResponseBody>({ url: `/nfd/algoPrice`, method: 'get' }, options)
}
